import styled from '@emotion/styled'

import { conditionalStyles } from 'component-library/__styling/conditional-styles'
import { colors } from 'component-library/__styling/settings'

const unset: string = undefined as any

export interface Props {
    stretchColumns?: boolean
    stretchSelf?: boolean
    fillContainer?: boolean
    hasBackgroundFill?: boolean
}

export const StyledContentWrapper = styled('div')<Props>(
    {
        width: '100%',
    },
    props => ({
        backgroundColor: props.hasBackgroundFill ? colors.white : unset,
        flexGrow: props.fillContainer ? 1 : undefined,
        height: props.stretchSelf ? '100%' : undefined,
        ...conditionalStyles(props.stretchColumns, {
            display: 'flex',
            flexDirection: 'column',
        }),
    })
)
